var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title mt-5" }, [
      _c("h3", { staticClass: "d-flex justify-content-center header" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("headers.hearing_test")) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "results-wrapper" }, [
        _c("div", { staticClass: "d-flex justify-content-center mt-5" }, [
          _c("span", { staticClass: "header header-2" }, [
            _vm._v(_vm._s(_vm.resultText))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-content-center mt-3" }, [
          _c("span", { staticClass: "header header-4" }, [
            _vm._v(_vm._s(_vm.secondaryResultText))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-content-center mt-5" }, [
          _c(
            "button",
            {
              staticClass: "button primary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("continue")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("actions.contact_me")))]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }